export default "/images/fax.svg?ca3ede474e854545b8ef79b3e76d82d1";